'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/promise-native-constructor.js
// module id = 89
// module chunks = 13